const React = require('react');
const PropTypes = require('prop-types');

class CornerFlag extends React.Component {
    render() {
        const message = this.props.message;
        if (message) {
            return (
                <div className="corner-flag">
                    <div className="corner-flag__ribbon">
                        <p className="corner-flag__message">{message}</p>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

CornerFlag.propTypes = {
    message: PropTypes.string
};

module.exports = CornerFlag;
